import Service from "./Service"
import trust from "../../assets/images/ecommerce/trust.svg"
import sales from "../../assets/images/databases/sales.svg"
import discover from "../../assets/images/webpages/discover.svg"

const seo = {
  t1: "SEO",
  header: [
    "We optimize your website.",
    "We make your business appear in the top results of Google.",
    "We help you reach more customers.",
  ],
  time: "15-30",
  benefits: [
    {
      img: sales,
      text: "Increase your sales",
    },
    {
      img: discover,
      text: "Appear in the top results of Google",
    },
    {
      img: trust,
      text: "Generate more trust with your customers",
    },
  ],
  info: "SEO",
};

const SEO = () => {
    return (
        <Service service={seo}/>
    )   
}

export default SEO